import { render, staticRenderFns } from "./Memorias.vue?vue&type=template&id=0c32f212&"
import script from "./Memorias.vue?vue&type=script&lang=ts&"
export * from "./Memorias.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports